import ajax from '@/lib/ajax'

/**
 * 读取随访短信模板列表
 * @param payload 
 */
export async function QueryFollowMessage(payload: any) {
    let res = await ajax.post('/api/services/app/FollowMessage/QueryFollowMessage', payload)
    return res.data.result
}

/**
 * 新增随访短信模板
 * @param payload 
 */
export async function InsertFollowMessage(payload: any) {
    let res = await ajax.post('/api/services/app/FollowMessage/InsertFollowMessage', payload)
    return res.data.result
}

/**
 * 修改随访短信模板
 * @param payload 
 */
export async function UpdateFollowMessage(payload: any) {
    let res = await ajax.put('/api/services/app/FollowMessage/UpdateFollowMessage', payload)
    return res.data.result
}

/**
 * 删除随访短信模板
 * @param payload 
 */
export async function DeleteFollowMessage(id: number) {
    let res = await ajax.delete('/api/services/app/FollowMessage/DeleteFollowMessage?id=' + id)
    return res.data.result
}


// WEBPACK FOOTER //
// ./src/api/follow/followMessage/index.ts